import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-tabs.tabs-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 32px 15px 29px;
  overflow: hidden;
}

#bens-servicos-tabs.tabs-container .tab-item {
  box-sizing: border-box;
  flex: 0 0 145px !important;
  cursor: pointer;
}

#bens-servicos-tabs.tabs-container .tab-item.bens-servicos-tab-para-sua-empresa {
  flex: 0 0 175px !important;
}

#bens-servicos-tabs.tabs-container .tab-item p {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: #222222;
  margin-bottom: 9px;
  transition: color linear 350ms;
}

#bens-servicos-tabs.tabs-container .tab-item span {
  display: block;
  background-color: #767676;
  height: 1px;
  width: 100%;
  box-sizing: border-box;
  transition: background-color linear 350ms;
}

#bens-servicos-tabs.tabs-container .tab-item.active p {
  color: #cc0000;
}

#bens-servicos-tabs.tabs-container .tab-item.active span {
  background-color: #cc0000;
  height: 2px;
}

#bens-servicos-tabs-scroll .embla__next,
#bens-servicos-tabs-scroll .embla__prev {
  display: none !important;
}

@media (min-width: 576px) {
  #bens-servicos-tabs.tabs-container .tab-item.bens-servicos-tab-para-sua-empresa {
    flex: 0 0 219px !important;
  }
}

@media (min-width: 992px) {
  #bens-servicos-tabs.tabs-container .tab-item p {
    margin-bottom: 10px;
  }

  #bens-servicos-tabs.tabs-container {
    padding: 42px 0 56px;
    justify-content: center;
   }
}
`;

export default styles;